module.exports = __webpack_public_path__ + "img/master-card.545a2cd.png";